// extracted by mini-css-extract-plugin
module.exports = {"topImage":"WashingServices_topImage__397PF","title":"WashingServices_title__1Hi2j","mainServices":"WashingServices_mainServices__393Jb","content":"WashingServices_content__1xmHj"};